import "./App.css";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import OsloMap from "./components/sections/maps/osloMap";
import TelcofyPin from "./components/ui/TelcofyPin";
import SolutionsPage from "./pages/SolutionsPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import SolutionDetailPage from "./pages/SolutionDetailPage";
import ArendalsukaPage from "./pages/ArendalsukaPage";
import VaulenSchoolPage from "./pages/VaulenSchoolPage";
import May17Page from "./pages/May17Page";
import EmergencyPreparednessPage from "./pages/EmergencyPreparednessPage";
import FrognPage from "./pages/FrognPage";
import FornebuPage from "./pages/FornebuPage";
import PlatformOverviewPage from "./pages/PlatformOverviewPage";
import PrivacyArchitecturePage from "./pages/PrivacyArchitecturePage";
import StatisticalQualityPage from "./pages/StatisticalQualityPage";
import ScrollToTop from "./components/layout/ScrollToTop";
import RouteAnalytics from "./components/layout/RouteAnalytics";
import CookieConsent from "./components/layout/CookieConsent";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import Footer from "./components/layout/Footer";

function App() {
  return (
    <div>
      <ScrollToTop />
      <RouteAnalytics />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/platform" element={<PlatformOverviewPage />} />
        <Route path="/platform/privacy" element={<PrivacyArchitecturePage />} />
        <Route path="/platform/statistical-quality" element={<StatisticalQualityPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/solutions/emergency-preparedness" element={<EmergencyPreparednessPage />} />
        <Route path="/solutions/:solutionSlug" element={<SolutionDetailPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/arendalsuka" element={<ArendalsukaPage />} />
        <Route path="/projects/may-17th" element={<May17Page />} />
        <Route path="/projects/vaulen-school" element={<VaulenSchoolPage />} />
        <Route path="/projects/frogn-city-development" element={<FrognPage />} />
        <Route path="/projects/road-closure-fornebu" element={<FornebuPage />} />
        <Route path="/projects/:projectSlug" element={<ProjectDetailPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
        <Route path="/oslo" element={<OsloMap />} />
        <Route path="/telcofy-pin" element={<TelcofyPin />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
